import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { getApplicant } from '../../../providers/api/applicant/applicantProvider';
import { Applicant } from '../../../providers/api/dtos/applicant';

export const APPLICANT_RID = '/v2/applicants';

export function useApplicant(applicantId?: number, options?: SWRConfiguration<Applicant, AxiosError>): SWRResponse<Applicant, AxiosError> {
  return useSWR(applicantId ? [APPLICANT_RID, applicantId] : null, () => getApplicant(applicantId!), options);
}
